module.exports = __webpack_public_path__ + "img/TZS09680.537be27a.jpeg";